import type { Product } from '@subaio/api-types/service'
import { Placeholder } from '@subaio/components'

import { ProductLogo } from 'components/ProductLogo'

import { Cell, ItemOption } from '../Styled'
import { Title } from '../Title'

type Props = {
	product: Product
	isSelected: boolean
	index: number

	onSelect: (args: { productId: string }) => void
}

export const SelectableProductItem = ({ product, isSelected, index, onSelect }: Props) => {
	const { id, title } = product

	return (
		<ItemOption isSelected={isSelected} checkboxStyle='plain' onClick={() => onSelect({ productId: id })}>
			<Cell>
				<ProductLogo {...product} size={32} border={false} />
			</Cell>
			<Cell expand>
				<Title>
					<Placeholder width={index % 2 === 0 ? '50%' : '70%'}>{title}</Placeholder>
				</Title>
			</Cell>
		</ItemOption>
	)
}
